// extracted by mini-css-extract-plugin
export var container = "_gf-1";
export var editor = "_gf-2";
export var resizable = "_gf-3";
export var wrapper = "_gf-0";